<template>
  <v-container class="overview-page">

    <v-row class="ma-0">
      <v-col cols="12">
        <h2 class="primary--text font-weight-bold pt-5 pl-2">
          <v-icon color="primary" large left>question_answer</v-icon>
          {{ $t('book/admin:process-answer.overview.title') }}
        </h2>

        <DataTable
            :enabledSearch="true"
            :addBtn="false"
            :headers="headers"
            :data="table.data"
            icon="check"
            @clickedButton1="accept"
            icon2="clear"
            @clickedButton2="reject"
            sortBy="processStepName"
            @cacheCommit="$store.commit('book/admin/storeProcessAnswerOverviewSearch', $event)"
            :cachedSearch="$store.state.book.admin.processAnswerOverviewSearch"
        />

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DataTable from "../../../core/components/DataTable/DataTable";
import ProcessAnswerService from "../../services/process/process-answer-service";
import Utils from "../../../core/services/utils";
import DataUtils from "@/modules/core/services/data-utils"
import ProcessAnswer from "@/modules/book/data/process-answer"

export default {
  name: "ProcessAnswerOverview",
  components: {
    DataTable
  },
  data() {
    return {
      table: {
        data: []
      }
    }
  },
  methods: {
    loadAnswers() {
      ProcessAnswerService.readAllFromAPI(
        (res) => {
          this.table.data = DataUtils.parseDataToObjectArray(res.data, ProcessAnswer);
        },
        (error) => {
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('book/admin:process-answer.overview.snackbar')}))
          this.$logger.error(error);
        }
      )
    },
    accept(item) {
      ProcessAnswerService.acceptAnswer(item.id,
        () => {
          Utils.sleep(process.env.VUE_APP_DIALOG_BOX_WAIT_MS).then(() => {
            //reload the table
            this.loadAnswers();
          });
        },
        () => {}
      )
    },
    reject(item) {
      ProcessAnswerService.rejectAnswer(item.id,
        () => {Utils.sleep(process.env.VUE_APP_DIALOG_BOX_WAIT_MS).then(() => {
            //reload the table
            this.loadAnswers();
          });
        },
        () => {}
      )
    }
  },
  computed: {
    headers() {
      return [
        {text: this.$t("book/admin:process-answer.overview.datatable.name"), value: 'processStepName'},
        {text: this.$t("book/admin:process-answer.overview.datatable.answer"), value: 'answer'},
        {text: this.$t("book/admin:process-answer.overview.datatable.settings"), value: 'controls', sortable: false},
      ]
    }
  },
  created() {
    this.loadAnswers();
  }
}

</script>
<style lang="scss">

.wrap-word {
  word-break: break-all;
}

</style>
